module.exports = __webpack_public_path__ + "img/vier_pretty.0ddaa648.jpg";